import React, { useState, useEffect } from 'react'; // Ensure React is imported

import logo from './logo.svg';
import './App.css';
import './index.css'

import { Layout, Space, Typography, Button } from 'antd';

import { createClient } from '@supabase/supabase-js'
import { Auth } from '@supabase/auth-ui-react'
import { ThemeSupa } from '@supabase/auth-ui-shared';
import BingoPage from './BingoPage.tsx';

const { Header, Content, Footer, Sider } = Layout;
const { Title } = Typography;
const supabase = createClient('https://mbbzinouimzgqqosgoyp.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1iYnppbm91aW16Z3Fxb3Nnb3lwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY1MTUzNDIsImV4cCI6MjA1MjA5MTM0Mn0.YZGzZ0ImDov2BHPakUwQRQ4-d2s6noEHUge6-nxN8no')

const LogoutButton = () => {
  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
  };

  return (
    <Button type="primary" danger onClick={handleLogout}>
      Logout
    </Button>
  );
};

export default function App() {
  const [session, setSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
    })

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (!session) {
    return (<Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />)
  }
  else {

    return <Layout>
    <Header
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        width: '100%',
        display: 'flex',
        alignItems: 'center'
      }}>
               <Title style={{color: 'white', width: '100%', textAlign: 'center'}}>BINGO 2025</Title>
               <LogoutButton/>
  </Header>
  <Content>
    <BingoPage supabase={supabase}/>
    </Content>
  </Layout>
  
}
}